module.exports = __webpack_public_path__ + "static/img/2.1e33214.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/2.png
// module id = iNGo
// module chunks = 0